/** Prices search (hub hero): the field, the desktop dropdown, the mobile layer and the rows inside them. */
export const PRICES_SEARCH_TEST_IDS = {
    ROOT: "prices-search",
    INPUT: "prices-search-input",
    SUBMIT: "prices-search-submit",
    CLEAR: "prices-search-clear",
    SPINNER: "prices-search-spinner",
    DROPDOWN: "prices-search-dropdown",
    MOBILE_LAYER: "prices-search-mobile-layer",
    MOBILE_BACK: "prices-search-mobile-back",
    MOBILE_INPUT: "prices-search-mobile-input",
    GROUP: "prices-search-group",
    OPTION: "prices-search-option",
    NUMBERS: "prices-search-numbers",
    NUMBER: "prices-search-number",
    SHOW_MORE: "prices-search-show-more",
    BANNER: "prices-search-banner",
    EMPTY: "prices-search-empty",
    EMPTY_CHIP: "prices-search-empty-chip",
    SKELETON: "prices-search-skeleton",
    NEARBY: "prices-search-nearby",
    RECENT_REMOVE: "prices-search-recent-remove",
    RECENT_CLEAR: "prices-search-recent-clear"
} as const;
/** Prices search (hub hero): the field, the desktop dropdown, the mobile layer and the rows inside them. */
export const PRICES_SEARCH_TEST_IDS = {
    ROOT: "prices-search",
    INPUT: "prices-search-input",
    SUBMIT: "prices-search-submit",
    CLEAR: "prices-search-clear",
    SPINNER: "prices-search-spinner",
    DROPDOWN: "prices-search-dropdown",
    MOBILE_LAYER: "prices-search-mobile-layer",
    MOBILE_BACK: "prices-search-mobile-back",
    MOBILE_INPUT: "prices-search-mobile-input",
    GROUP: "prices-search-group",
    OPTION: "prices-search-option",
    NUMBERS: "prices-search-numbers",
    NUMBER: "prices-search-number",
    SHOW_MORE: "prices-search-show-more",
    BANNER: "prices-search-banner",
    EMPTY: "prices-search-empty",
    EMPTY_CHIP: "prices-search-empty-chip",
    SKELETON: "prices-search-skeleton",
    NEARBY: "prices-search-nearby",
    RECENT_REMOVE: "prices-search-recent-remove",
    RECENT_CLEAR: "prices-search-recent-clear"
} as const;
